import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import CustomizedAccordion from 'components/CustomizedAccordion';
import { sanlamDarkGrayishBlue, sanlamVeryDarkBlue } from 'Material-UI/colors';
import {
  StyledCaptions,
  ItemWrapper,
  SizedSmallSectionHeader,
  StyledList,
  StyledImg,
  AccordionDetailsCaptions,
} from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/MySupportServices/styles';
import messages from 'containers/AutoDetailsPage/messages';
import { translate } from 'helpers/intl';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

const MySupportServices: React.FC<{
  intl: IntlShape;
  servicesAssitance: { icon: string; title: string; description: string }[];
}> = (props) => {
  const [expanded, setExpanded] = useState<boolean | number>(false);

  const handleChange = (index: number) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    setExpanded(isExpanded ? index : false);
  };
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  return (
    <React.Fragment>
      {props.servicesAssitance ? (
        <>
          <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
            {translate({ ...messages.MySupportServices }, props)}
          </SizedSmallSectionHeader>
          <Grid spacing={2} container>
            {props.servicesAssitance.map((item, index) => (
              <Grid key={index} item xs={12} sm={6}>
                <CustomizedAccordion
                  expanded={expanded === index}
                  changeHandler={handleChange(index)}
                  summary={
                    <ItemWrapper reverse={reverse}>
                      <StyledImg alt="support-icon" src={item.icon} />
                      <StyledCaptions
                        weight="500"
                        color={sanlamDarkGrayishBlue}
                      >
                        {item.title}
                      </StyledCaptions>
                    </ItemWrapper>
                  }
                  details={
                    <StyledList>
                      {item.description.split('\n').map((detail, index) => (
                        <li key={index}>
                          <AccordionDetailsCaptions weight="400">
                            {`- ${detail}`}
                          </AccordionDetailsCaptions>
                        </li>
                      ))}
                    </StyledList>
                  }
                />
              </Grid>
            ))}
          </Grid>
        </>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default injectIntl(MySupportServices);
